// „Neu"-Ansicht des Chats: entweder eine Person anschreiben (Liste wie bisher) oder eine
// freie Gruppe gründen (Name + Kollegenauswahl). Reiner Baustein ohne eigenen useChat() —
// die Daten kommen per Props, die Aktionen laufen über Callbacks nach oben.
import { useState, type CSSProperties } from 'react';
import { kollegeName, type ChatGruppe, type Kollege } from '../../../../lib/chat/nachrichten';
import { gruendeGruppe } from '../../../../lib/chat/api';
import { FARBE } from '../../pille-stil';
import { Avatar } from './Avatar';

const FELD: CSSProperties = {
  width: '100%', height: 36, borderRadius: 12, border: 'none', outline: 'none', padding: '0 12px',
  background: 'rgba(255,255,255,0.08)', color: '#fff', fontFamily: 'inherit', fontSize: 14, fontWeight: 600,
};

export function NeuDialog({ kollegen, meineId, onPerson, onGruppe, onFehler }: {
  kollegen: Kollege[]; meineId: string;
  onPerson: (id: string) => void; onGruppe: (g: ChatGruppe) => void;
  onFehler?: (msg: string) => void;
}) {
  const [art, setArt] = useState<'person' | 'gruppe'>('person');
  const [name, setName] = useState('');
  const [gewaehlt, setGewaehlt] = useState<string[]>([]);
  const [laedt, setLaedt] = useState(false);
  // Die Fehlerzeile der Seite hängt am Verlauf und ist ohne offenes Gespräch unsichtbar —
  // beim Gründen ist genau das der Normalfall. Deshalb hier zusätzlich direkt am Knopf.
  const [fehler, setFehler] = useState<string | null>(null);

  async function gruenden() {
    if (!name.trim() || laedt) return;
    setLaedt(true);
    setFehler(null);
    const neu = await gruendeGruppe(name, meineId, gewaehlt);
    setLaedt(false);
    if (neu) { setName(''); setGewaehlt([]); onGruppe(neu); }
    else {
      const msg = 'Gruppe konnte nicht erstellt werden — bitte erneut versuchen.';
      setFehler(msg);
      onFehler?.(msg);
    }
  }

  return (
    <div className="flex flex-col" style={{ gap: 6 }}>
      <div className="flex" role="tablist" style={{ padding: 3, borderRadius: 12, background: 'rgba(0,0,0,0.28)', gap: 2 }}>
        {(['person', 'gruppe'] as const).map((a) => (
          <button key={a} type="button" role="tab" aria-selected={art === a} onClick={() => setArt(a)}
            className="flex-1 cursor-pointer"
            style={{ height: 28, borderRadius: 9, border: 'none', fontFamily: 'inherit', fontSize: 12.5, fontWeight: art === a ? 700 : 500,
              background: art === a ? '#fff' : 'transparent', color: art === a ? '#111' : 'rgba(235,235,245,0.7)', transition: 'background .2s' }}>
            {a === 'person' ? 'Person' : 'Gruppe'}
          </button>
        ))}
      </div>
      {art === 'person' ? (
        kollegen.map((k) => (
          <button key={k.id} type="button" onClick={() => onPerson(k.id)}
            className="pille-chatzeile flex w-full cursor-pointer items-center text-left"
            style={{ gap: 10, padding: '6px 8px', borderRadius: 12, border: 'none', fontFamily: 'inherit', color: '#fff' }}>
            <Avatar name={kollegeName(k)} bild={k.avatar_url} groesse={36} />
            <span className="truncate" style={{ fontSize: 14, fontWeight: 600 }}>{kollegeName(k)}</span>
          </button>
        ))
      ) : (
        <>
          <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Name der Gruppe" aria-label="Name der Gruppe" className="pille-feld" style={FELD} />
          {kollegen.map((k) => (
            <label key={k.id} className="pille-chatzeile flex cursor-pointer items-center" style={{ gap: 10, padding: '6px 8px', borderRadius: 12 }}>
              <input type="checkbox" checked={gewaehlt.includes(k.id)} style={{ accentColor: FARBE.blau, width: 16, height: 16 }}
                onChange={(e) => setGewaehlt((v) => e.target.checked ? [...v, k.id] : v.filter((x) => x !== k.id))} />
              <Avatar name={kollegeName(k)} bild={k.avatar_url} groesse={28} />
              <span className="truncate" style={{ fontSize: 14, fontWeight: 600 }}>{kollegeName(k)}</span>
            </label>
          ))}
          {fehler && (
            <div role="alert" style={{ padding: '8px 10px', borderRadius: 12, fontSize: 12, fontWeight: 600, background: 'rgba(255,69,58,0.14)', color: '#ff8a80' }}>
              {fehler}
            </div>
          )}
          <button type="button" onClick={() => void gruenden()} disabled={!name.trim() || laedt}
            className="cursor-pointer"
            style={{ height: 40, borderRadius: 12, border: 'none', fontFamily: 'inherit', fontSize: 14, fontWeight: 800, background: FARBE.blau, color: '#fff', opacity: !name.trim() || laedt ? 0.35 : 1 }}>
            Gruppe gründen
          </button>
        </>
      )}
    </div>
  );
}
